// `plural(count, oneKey, manyKey, params)` — the ONE way a count-bearing string
// picks its form. Authored copy carries two keys per phrase (…One / …Many); a
// single key with "(s)" in it is a placeholder that reaches the reader.

import { t } from './t';

export function plural(
  count: number,
  oneKey: string,
  manyKey: string,
  params: Record<string, string | number>,
): string {
  return t(count === 1 ? oneKey : manyKey, params);
}
